module.exports = "<div *ngIf=\"message\" [ngClass]=\"{ 'alert': message, 'alert-success': message.type === 'success', 'alert-danger': message.type === 'error', 'alert-warning': message.type === 'warn', 'alert-dismissible': message }\" id=\"alert_message\">\r\n    <button type=\"button\" class=\"close\" data-dismiss=\"alert\" aria-label=\"Close\"><span aria-hidden=\"true\">&times;</span></button>\r\n    {{message.text}}\r\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/common/alert/alert.component.html
// module id = 1086
// module chunks = 0